module.exports = __webpack_public_path__ + "img/authenticator.playstore.954b6e01.png";